import { DELETE_DMX_PROFILE, DELETE_DMX_PROFILE_SUCCESSFUL, DELETE_DMX_PROFILE_FAILED } from './actionTypes';

export const deleteDmxProfile = (profile) => {
  return {
    type: DELETE_DMX_PROFILE,
    payload: { profile },
  };
};

export const deleteDmxProfileSuccessful = (message) => {
  return {
    type: DELETE_DMX_PROFILE_SUCCESSFUL,
    payload: message,
  };
};

export const deleteDmxProfileFailed = (message) => {
  return {
    type: DELETE_DMX_PROFILE_FAILED,
    payload: message,
  };
};
